import { defineMessages } from 'react-intl-next';

export const messages: {
    feedbackFooter: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    searchChangeMessage: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	feedbackFooter: {
		id: 'search_dialog_feedback_footer',
		defaultMessage: 'Help us improve search',
		description: 'Text in the search dialog to prompt users to provide feedback',
	},
	searchChangeMessage: {
		id: 'search_dialog_search_change_message',
		defaultMessage: 'Why has search changed?',
		description: 'Text in the search dialog for more information about the search change',
	},
});
